<script>
import updateTick from '@/mixins/update-tick.js'

export default {
  mixins: [
    updateTick
  ],

  props: {
    keyMap: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data () {
    return {
      keysPressed: {},
      keydownHandler: undefined,
      keyupHandler: undefined
    }
  },

  mounted () {
    document.addEventListener('keydown', this.keydownHandler = this.keydown.bind(this))
    document.addEventListener('keyup', this.keyupHandler = this.keyup.bind(this))
  },

  beforeDestroy () {
    document.removeEventListener('keydown', this.keydownHandler)
    document.removeEventListener('keyup', this.keyupHandler)
  },

  render () {
    return undefined
  },

  methods: {
    update () {
      Object.keys(this.keyMap).forEach((mapKey) => {
        const map = this.keyMap[mapKey]

        Object.keys(this.keysPressed).forEach((key) => {
          if (map.includes(key)) {
            this.$emit(`${mapKey}-down`)
            this.$emit('keydown', mapKey)
          }
        })
      })
    },

    keydown (evt) {
      // evt.preventDefault()

      const key = evt.key.toLowerCase()

      Object.keys(this.keyMap).forEach((k) => {
        const map = this.keyMap[k]

        if (map.includes(key)) {
          this.$emit(`${k}-press`)
          this.$emit('keypress', k)

          this.$set(this.keysPressed, key, true)
        }
      })
    },

    keyup (evt) {
      // evt.preventDefault()

      const key = evt.key.toLowerCase()
      this.$delete(this.keysPressed, key)
    }
  }
}
</script>
